module.exports = __webpack_public_path__ + "static/media/undraw_analysis_4jis.25a23828.svg";